import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function CommercialLaw() {
  return (
     <motion.div
      className="max-w-4xl mx-auto px-6 py-12 text-center"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
   
      <h1 className="text-3xl md:text-4xl font-bold mb-6">Commercial Law</h1>

      <p className="text-lg text-gray-700 leading-relaxed mb-6 text-left">
        At Falcon Law, we help businesses navigate the complex world of
        commercial law. Our focus is on agreements, contracts, and business
        transactions—the legal foundation of every successful enterprise.
      </p>

      <ul className="list-disc list-inside text-left text-lg text-gray-700 leading-relaxed mb-8">
        <li>
          Drafting enforceable contracts such as partnership arrangements,
          distribution arrangements, lease agreements, and confidentiality
          (non-disclosure) agreements, tailored to your business needs
        </li>
        <li>
          Reviewing your existing agreements to identify risks, ensure
          compliance, and protect your interests
        </li>
        <li>
          Conducting negotiations to achieve fair contractual terms
        </li>
        <li>
          Providing legal guidance to prevent disputes
        </li>
      </ul>

      <Link
        to="/contact"
        className="inline-block px-6 py-3 rounded-lg bg-blue-900 text-white font-semibold shadow hover:bg-blue-800 transition"
      >
        Request Consultation
      </Link>
      </motion.div>
    
  );
}
